// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__QktOC","label":"Section_label__2HGqg","contentWrap":"Section_contentWrap__3VdcT","footer":"Section_footer__3jqCU","footerInner":"Section_footerInner__2bt6F"};